<template>
    <h1 class="title">Order List</h1>
    <section class="new-order">
        <h1>Dashboard!!</h1>
    </section>
</template>

<script>
export default {}
</script>

<style lang="scss">
    
    .title {
        margin-left: 30px;
        margin-top: 30px;
        font-weight: normal;
    }
    
    .new-order {
        margin-top: 30px;
        margin-left: 30px;
        margin-right: 30px;
        border-top: 4px solid var(--primary);
        background-color: var(--white);

        h1 {
            padding: 30px;
        }
    }

</style>